import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ArmadoresService } from "./armadores.service";
import { ArmadoresModel } from "./armadores.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal, $: any;

@Component({
  selector: 'app-armadores',
  templateUrl: './armadores.component.html'
})
export class ArmadoresComponent extends Components implements OnInit {

  armadores: ArmadoresModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "nome": "" };

  constructor(
    formBuilder: FormBuilder,
    private armadoresService: ArmadoresService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      nome: []
    });

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '28') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  delete(armador) {
    let armadores = this.armadores;
    let armadoresService = this.armadoresService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarArmador') + armador.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(armadores);
        }

        let index = armadores.indexOf(armador);
        armadores.splice(index, 1);

        armadoresService.apagar(armador.id)
          .subscribe(res => {
            self.armadores = armadores;
          },
            err => {
              armadores.splice(index, 0, armador);
              self.armadores = armadores;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    if (this.filtroPesquisa.nome != '') {
      filtros['nome'] = "**:" + this.filtroPesquisa.nome;
    }

    this.armadoresService.getPaginacao(pagina, this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.armadores = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "nome": "" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}




// WEBPACK FOOTER //
// ./src/app/armadores/armadores.component.ts